import * as tslib_1 from "tslib";
import { Component } from "vue-property-decorator";
import { DropdownControl } from "../control/dropdown-control";
// import { Select, Tooltip } from "@h3/antd-vue";
import { Select, Tooltip } from "@h3/antd-vue";
let Dropdown = class Dropdown extends DropdownControl {
    // testVal:any 
    onChange(val) {
        this.hasSelectBatchImport = false;
        if (val && val.length > 0) {
            this.setValue(Array.isArray(val) ? val.slice() : val);
        }
        else {
            this.ctrl.value = null;
        }
        if (!this.multiple) {
            return;
        }
        super.resetDisableds();
    }
    getOPt() {
        super.getOptions();
    }
    clearOption(change) {
        this.options = [];
        this.ctrl.value = null;
    }
    destroyed() {
        super.destroyed();
    }
};
Dropdown = tslib_1.__decorate([
    Component({
        name: "dropdown",
        components: {
            ATooltip: Tooltip,
            ASelect: Select,
            ASelectOption: Select.Option,
        },
    })
], Dropdown);
export default Dropdown;
